import { ColDef } from "ag-grid-community";
import {
  createGroupColumn,
  ColumnTypeEnum,
} from "../../../../../../../components";
import { calculateReturnOnPremium } from "../../../../../../../utils";

export const recentlyTradedPositionsColumnDefs: ColDef[] = [
  createGroupColumn("Last Trade Date", "positionDate", ColumnTypeEnum.Date, {
    sort: "asc",
    aggFunc: "distinct",
    minWidth: 140,
    hide: true,
    rowGroup: true,
  }),

  createGroupColumn(
    "Underlying Symbol",
    "underlyingSymbol",
    ColumnTypeEnum.Logo,
    {
      suppressColumnsToolPanel: true,
      hide: true,
      rowDrag: true,
    }
  ),

  createGroupColumn("Underlying", "underlyingName", ColumnTypeEnum.Text, {
    rowGroup: true,
    hide: true,
    sort: "asc",
    rowDrag: true,
    suppressColumnsToolPanel: true,
    valueGetter: (params) => {
      if (params.data.underlyingType === "Future") {
        return params.data.underlyingName;
      } else {
        return params.data.underlyingSymbol;
      }
    },
  }),

  createGroupColumn("Position Group", "positionName", ColumnTypeEnum.Text, {
    rowGroup: true,
    hide: true,
    sort: "asc",
    rowDrag: true,
    suppressColumnsToolPanel: true,
  }),

  // createGroupColumn(
  //   "Underlying Symbol",
  //   "underlyingSymbol",
  //   ColumnTypeEnum.Logo,
  //   {
  //     suppressColumnsToolPanel: true,
  //     hide: true,
  //     rowDrag: true,
  //   }
  // ),

  createGroupColumn("Avg. Price", "averagePrice", ColumnTypeEnum.Currency, {
    cellRendererParams: { noFormatting: true },
    hide: false,
    aggFunc: "none",
  }),

  createGroupColumn(
    "Gross proceeds",
    "grossProceeds",
    ColumnTypeEnum.Currency,
    { cellRendererParams: { showDirection: true }, aggFunc: "sum" }
  ),

  createGroupColumn("Net proceeds", "netProceeds", ColumnTypeEnum.Currency, {
    cellRendererParams: { showDirection: true },
    aggFunc: "sum",
  }),

  createGroupColumn("Costs", "costs", ColumnTypeEnum.Currency, {
    hide: false,
    aggFunc: "sum",
    valueGetter: (params) => {
      return params.data.costs * -1;
    },
  }),

  createGroupColumn("Premium", "premium", ColumnTypeEnum.Currency, {
    cellRendererParams: { showDirection: true },
    aggFunc: "sum",
  }),

  createGroupColumn("Cost Basis", "costBasis", ColumnTypeEnum.Currency, {
    cellRendererParams: { showDirection: true },
    aggFunc: "sum",
  }),

  createGroupColumn(
    "Return On Premium",
    "returnOnPremium",
    ColumnTypeEnum.Percentage,
    {
      cellRendererParams: { showDirection: true },
      aggFunc: "returnOnPremium",
      valueGetter: (params) => {
        return calculateReturnOnPremium(
          params.data.premium,
          params.data.realisedPnl,
          params.data.unrealisedPnl
        );
      },
    }
  ),
];
